export enum URL_TYPE{
    EMOJI="emoji",
    IMAGE="image",
    VIDEO="video",
    PDF="pdf",
    WORD_DOCUMENT="word_file"
}